import { render } from "./topTrendingArticles.vue?vue&type=template&id=8d537736&scoped=true"
import script from "./topTrendingArticles.vue?vue&type=script&lang=js"
export * from "./topTrendingArticles.vue?vue&type=script&lang=js"

import "./topTrendingArticles.vue?vue&type=style&index=0&id=8d537736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d537736"]])

export default __exports__